import { createContext } from 'react';

export type LoginCompletion = (result: { token: string; was_created: boolean }) => Promise<void>;

// Alternate hosts can own session setup; the app uses its normal credential flow by default.
export const LoginCompletionContext = createContext<LoginCompletion | null>(null);
